export default __webpack_public_path__ + "static/media/client.09086948.png";